"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DesignSchema = void 0;
const zod_1 = require("zod");
const pcb_1 = require("./pcb");
const SchematicModel_1 = require("./SchematicModel");
exports.DesignSchema = zod_1.default.discriminatedUnion('modelType', [
    pcb_1.PcbModelSchema,
    SchematicModel_1.SchematicModelSchema,
]);
//# sourceMappingURL=Design.js.map